import { Grid, Typography, Box } from '@mui/material';
import {
  GRID_CHECKBOX_SELECTION_COL_DEF,
  GridColDef,
} from '@mui/x-data-grid-pro';
import { useState } from 'react';

import DataTable from 'portal/src/components/common/DataTable';
import { numberFormatter } from 'portal/src/utils/numberFormatter';

import { dateFormatter } from '../../common';

interface ComponentProps {
  fiscalMonths: Array<any>;
  onMonthSelected: (e: any) => any;
}

const gridColumns: GridColDef[] = [
  {
    ...GRID_CHECKBOX_SELECTION_COL_DEF,
    renderHeader: () => <></>,
  },
  {
    field: 'month',
    headerName: 'Month',
    headerAlign: 'center',
    align: 'center',
    width: 70,
    valueFormatter: (value) => value + 1,
  },
  {
    field: 'period',
    headerName: 'Budget Period',
    flex: 1.1,
    valueFormatter: (value) => dateFormatter(new Date(value)),
  },
  {
    field: 'cost',
    headerName: 'Total Cost',
    flex: 1,
    valueFormatter: (value) => numberFormatter(value),
  },
];

export const FiscalMonthSelector = ({
  fiscalMonths,
  onMonthSelected,
}: ComponentProps) => {
  const [selectedRows, setSelectedRows] = useState([]);

  const handleSelectedRowId = ({ ids }, { api }) => {
    const idsList = [...ids];
    const rowIds = api.getAllRowIds();

    if (idsList.length) {
      const rowSelected = idsList.pop();
      if (rowSelected !== undefined && rowIds.includes(rowSelected)) {
        setSelectedRows([rowSelected]);
        onMonthSelected(rowSelected);
      }
    } else if (rowIds.includes(selectedRows[0])) {
      setSelectedRows([]);
      onMonthSelected(undefined);
    }
  };
  return (
    <Box display="flex" gap={2} width="100%">
      {[fiscalMonths.slice(0, 6), fiscalMonths.slice(6, 12)].map(
        (rowGrid, idx) => (
          <Box
            key={idx}
            display="flex"
            flexDirection="column"
            gap={1}
            width="100%"
          >
            <Typography variant="subtitle1">
              {idx > 0 ? 'Second' : 'First'} Fiscal Semester
            </Typography>
            <DataTable
              columns={gridColumns}
              disableMultipleRowSelection
              hideFooter
              isRowNavigation={false}
              onRowSelectionModelChange={handleSelectedRowId}
              rows={rowGrid}
              rowSelectionModel={{
                ids: new Set(selectedRows),
                type: 'include',
              }}
            />
          </Box>
        ),
      )}
    </Box>
  );
};
